import { addToast } from '@ydistri/utils';
import { Modal } from 'antd';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useDisplayStoreLabelFormatter } from '../../hooks/useDisplayStoreLabel';
import { ReduxState, useAppDispatch } from '../../store';
import { useDeleteStoreScheduleMutation } from '../ProjectAdministration/StoresSchedule/apiStoreSchedules';
import { AvailableModals, closeModal } from './modalSlice';

const modalId = AvailableModals.STORE_SCHEDULE_DELETE;

const StoreScheduleDeleteModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const storeSchedule = useSelector(
    (state: ReduxState) => state.modal.modalData[modalId]?.storeSchedule,
  );

  const [deleteStoreSchedule, { isLoading: deleting }] = useDeleteStoreScheduleMutation();
  const formatStoreLabel = useDisplayStoreLabelFormatter();

  const handleClose = useCallback(() => dispatch(closeModal()), [dispatch]);

  const handleDelete = useCallback(() => {
    if (!storeSchedule) return;

    deleteStoreSchedule(storeSchedule.storeScheduleId)
      .unwrap()
      .then(() => {
        dispatch(addToast({ message: 'Closure deleted' }));
      })
      .catch(() => {
        dispatch(addToast({ message: 'Closure was not deleted', isError: true }));
      })
      .finally(handleClose);
  }, [storeSchedule, deleteStoreSchedule, dispatch, handleClose]);

  if (!storeSchedule) return null;

  return (
    <Modal
      title="Delete this closure?"
      centered
      open={true}
      okText="Delete"
      okButtonProps={{ danger: true, loading: deleting }}
      onOk={handleDelete}
      onCancel={handleClose}
    >
      {formatStoreLabel(
        storeSchedule.store.name,
        storeSchedule.store.customerStoreId,
        storeSchedule.store.code,
      )}{' '}
      will be back in the redistribution proposal for this period. Templates that switched this
      closure off lose that setting.
    </Modal>
  );
};

export default StoreScheduleDeleteModal;
